import React, { useContext } from 'react';
import { LangContext } from '../decorators/Language';
import PropTypes from 'prop-types';

export const t = (textName, defaultStr, page = 'all', translation, group = 'common') => {
    if (!translation) return '';

    if (translation && `${translation[textName]}` === 'undefined') {
        console.warn(`Translation ${textName} on page ${page}, group - ${group} not found`);
    }
    return (translation && translation[textName]) || defaultStr;
};
const T = ({ textName, defaultStr, vars = {}, page = 'all', group = 'common', customTranslates = false, customLoading }) => {
    const { translation, loading } = useContext(LangContext) || {};
    if (loading || customLoading) return null;
    const text = customTranslates
        ? customTranslates[textName] || defaultStr
        : (translation && translation[textName]) || defaultStr;
    if (
        (customTranslates && `${customTranslates[textName]}` === 'undefined') ||
        (!customTranslates && translation && `${translation[textName]}` === 'undefined')
    ) {
        console.warn(`Translation ${textName} on page ${page}, group - ${group} not found`);
    }
    return (
        <>
            {text.split('${').reduce((arr, part, idx) => {
                if (idx === 0) {
                    arr.push(<React.Fragment key={`${textName}${idx}`}>{part}</React.Fragment>);
                    return arr;
                }

                const splitPart = part.split('}');
                const text = splitPart.slice(1).join('}');
                arr.push(<React.Fragment key={`${textName}var${idx}`}>{vars[splitPart[0]]}</React.Fragment>);
                arr.push(<React.Fragment key={`${textName}text${idx}`}>{text}</React.Fragment>);
                return arr;
            }, [])}
        </>
    );
};

export const tToString = (component) => {
    if (component?.constructor === Number) {
        return component;
    }
    if (typeof component === 'string') {
        return component;
    }
    if (!component) {
        return '';
    }
    if (!component.props) {
        return '';
    }
    const { defaultStr } = component.props;
    return defaultStr;
};

T.propTypes = {
    textName: PropTypes.string,
    defaultStr: PropTypes.string,
    vars: PropTypes.object,
    page: PropTypes.string,
    group: PropTypes.string,
    customTranslates: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    customLoading: PropTypes.bool
};

export default T;
